const DisabledCheckIcon = ({ size, rounded }: { size: number; rounded: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 2}
      height={size + 2}
      viewBox="0 0 25 25"
      fill="none"
      style={{ marginLeft: '-1px', marginTop: '-1px' }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="24"
        height="24"
        rx={Math.max(parseFloat(rounded) - 3, 0)}
        fill="#CFD0D8"
        stroke="#C6C8D2"
      />
    </svg>
  );
};
export default DisabledCheckIcon;
